
import { Component, Prop, Vue } from "vue-property-decorator";
import { TEmployeeSummary } from "@/models/employees";
import EmployeeSummaryActive from "./EmployeeSummaryActive.vue";
import EmployeeSummaryItem from "./EmployeeSummaryItem.vue";
import { SMUser } from "@/store";

@Component({
  components: {
    EmployeeSummaryActive,
    EmployeeSummaryItem,
  },
})
export default class EmployeeSummaryDetails extends Vue {
  @Prop({ type: Object, required: true }) readonly employeeSummary!: TEmployeeSummary;

  statuses = {
    undetermined: this.$root.$tc("labels.undetermined"),
    compliant: this.$root.$tc("labels.compliant"),
    not_compliant: this.$root.$tc("labels.notCompliant"),
  };

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  get complianceStatus() {
    const status = this.employeeSummary?.compliance;

    if (this.isComplianceBlocked || !status) return this.$root.$tc("labels.undetermined");

    return this.statuses[status];
  }

  get classes() {
    if (this.complianceStatus === this.$root.$tc("labels.compliant")) return `compliant`;

    if (this.complianceStatus === this.$root.$tc("labels.notCompliant")) return `noncompliant`;

    return `compliant_unknown`;
  }
}
